import { render, staticRenderFns } from "./new-client.modal.vue?vue&type=template&id=26ac28be&scoped=true&"
import script from "./new-client.modal.vue?vue&type=script&lang=js&"
export * from "./new-client.modal.vue?vue&type=script&lang=js&"
import style0 from "./new-client.modal.vue?vue&type=style&index=0&id=26ac28be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ac28be",
  null
  
)

export default component.exports